import { UseQueryResult, useQuery } from 'react-query';
import { SalesPortalPackageList } from 'types';
import { client } from 'utils/api-client';

export default function useAthleteSalesPortalPackages(
  gym: string | undefined,
  search?: string,
  profileId?: string,
): UseQueryResult<{ data: Array<SalesPortalPackageList> }> {
  return useQuery(
    ['athleteSalesPortalPackages', gym, search, profileId],
    () =>
      client.get(
        `packages/athlete-sales-portal-list/?gym=${gym}${
          search ? `&search=${encodeURIComponent(search)}` : ''
        }`,
      ),
    {
      enabled: !!gym,
    },
  );
}
